import React from 'react';

/**
 * TabPanel - A reusable tabbed interface component
 * 
 * @param {Object} props
 * @param {Array} props.tabs - Array of tab objects with {id, label} properties
 * @param {string} props.activeTab - ID of the currently active tab
 * @param {Function} props.onTabChange - Function to call when tab is changed
 * @param {React.ReactNode[]} props.children - React children (content for each tab) - must be an array corresponding to tabs
 */
const TabPanel = ({ tabs, activeTab, onTabChange, children }) => {
  return (
    <div>
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-6" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors
                ${activeTab === tab.id
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`
              }
              aria-current={activeTab === tab.id ? 'page' : undefined}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="py-6">
        {React.Children.map(children, (child, index) => (
          tabs[index]?.id === activeTab ? child : null
        ))}
      </div>
    </div>
  );
};

export default TabPanel; 